module.exports = __webpack_public_path__ + "static/media/lcd housing.e7dc250c.png";